import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { ConsultationService, DialogService, VisiteService } from '../../../../../services'
import { ConfirmComponent } from '../confirm-dialog/confirm.component'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { Observable, forkJoin } from 'rxjs'
import { map } from 'rxjs/operators'

const KEY = 'confirm-dialog'

@Component({
  selector: 'consultation-statechange',
  templateUrl: './consultation-statechange.component.html',
  styleUrls: ['./consultation-statechange.component.scss']
})
export class ConsultationStateChangeDialog extends BaseDialogComponent implements OnInit {
  visites: any = [];
  consultations: any = [];
  visiteStateSelected: any;
  consultStateSelected: any;
  visiteStateList: any;
  consultStateList: any;
  visitesSelected: any[] = [];
  consultSelected: any[] = [];
  loading : boolean = false;
  constructor(
    public dialogRef: MatDialogRef<ConsultationStateChangeDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    dialogService: DialogService,
    private visiteService: VisiteService,
    private consultationService: ConsultationService,
    changeDetectorRef: ChangeDetectorRef,
    private _snackbar: MatSnackBar
  ) {
    super(dialogRef, dialogService, changeDetectorRef)
  }

  ngOnInit() {
    console.log("data",this.data)
    if(this.data != undefined && this.data){

      if(this.data.visites != undefined && this.data.visites){
        this.getVisiteStateList();
        this.data.visites.forEach(vis => {
          this.visitesSelected.push(vis.ID);
        });
        this.visites = this.data.visites;
      }
      if(this.data.consultations != undefined && this.data.consultations){
        this.getConsultStateList();
        this.data.consultations.forEach(cons => {
          this.consultSelected.push(cons.ID);
        });
        this.consultations = this.data.consultations;
      }
    }
    this.changeDetectorRef.detectChanges();
    console.log("___cons",this.consultations, this.visites,this.visites.length,this.consultations.length)
  }

  check(id,type, event){
    var currentList = null;
    if(type == "visite")
      currentList = this.visitesSelected;
    else if(type == "consult")
      currentList = this.consultSelected;
    if(currentList){
      if (event.checked) {
        currentList.push(id);
      } 
      else {
        const index = currentList.indexOf(id);
        if (index > -1) {
          currentList.splice(index, 1);
        }
      }
    }
  }

  getDateLibelle(object) {
    const dateDebut = new Date(object.date_debut);
    const dateFin = new Date(object.date_fin);

    const jour = String(dateDebut.getDate()).padStart(2, '0');
    const mois = String(dateDebut.getMonth() + 1).padStart(2, '0');
    const annee = dateDebut.getFullYear();

    const heureDebut = String(dateDebut.getHours()).padStart(2, '0');
    const minuteDebut = String(dateDebut.getMinutes()).padStart(2, '0');
    const heureFin = String(dateFin.getHours()).padStart(2, '0');
    const minuteFin = String(dateFin.getMinutes()).padStart(2, '0');

    return `Le ${jour}/${mois}/${annee} De ${heureDebut}h${minuteDebut} à ${heureFin}h${minuteFin}`;
}

getVisiteStateList(){
  this.visiteService.getVisiteEtats().subscribe((res) => {
    if (res.result) {
      this.visiteStateList=res.result;
    }
  });
}

getConsultStateList(){
  this.consultationService.etats().subscribe((res) => {
    if (res.result) {
      this.consultStateList=res.result;
    }
  })
}

onClickSave(){
  var libelle = "Êtes vous sûr(e) de vouloir changer l'état de ";
  if(this.consultSelected.length>0){
    libelle += this.consultSelected.length + " séance(s)";
    if(this.visitesSelected.length>0)
      libelle+=  " et de ";
  }
  if(this.visitesSelected.length>0){
    libelle += this.visitesSelected.length + " rendez-vous";
  }
  libelle+="?";

  const confDialogRef = this.dialogService.open(ConfirmComponent, {
    data : {
      libelle : libelle
    }
  });
  confDialogRef.afterClosed().subscribe(res => {
    if(res === "true"){
      this.loading = true;
      if (this.visitesSelected.length > 0 || this.consultSelected.length > 0) {
        const observables = [];

        if (this.visitesSelected.length > 0) {
          const paramsVisite = {
            etat: this.visiteStateSelected,
            visite: this.visitesSelected
          };
          const visiteObservable = this.visiteService.setMultipleVisite(paramsVisite).pipe(
            map(response => ({ id: 'visite', response }))
          );
          observables.push({ id: 'visite', observable: visiteObservable });
        }
        
        if (this.consultSelected.length > 0) {
          const consultObservable = this.consultationService.setMultiConsultationStates(this.consultSelected, this.consultStateSelected.ID).pipe(
            map(response => ({ id: 'consult', response }))
          );
          observables.push({ id: 'consult', observable: consultObservable });
        }
        
        forkJoin(observables.map(item => item.observable)).subscribe((results: Array<{ id: string, response: JSONRpcResponse }>) => {
          const returnArray = {
            consultations: [],
            visites: []
          };
          results.forEach(res => {
            if (res.response.error) {
              this._snackbar.open(res.response.error.message + " : " + res.response.error.data, '', {
                duration: 2000,
              });
            } else if (res.response.result) {
              this._snackbar.open("Changements d'état effectués", '', {
                duration: 2000,
              });
              if (res.id === 'visite') {
                returnArray.visites = res.response.result
              } else if (res.id === 'consult') {
                returnArray.consultations = res.response.result;
              }
            }
          });
          this.loading = false;
          console.log("returnArray",returnArray);
          this.dialogRef.close(returnArray);
        });
      }
    }
  })
}

}
